import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  deleteArticle,
  getArticles,
  getDeletedArticles,
  setViewCount,
} from "../../api/helpCenterApi";
import logo_icon from "../../assets/cargotool-icon.png";
import LoadingSpinner from "../LoadingSpinner";
import AddHelpArticle from "./AddHelpArticle";
import CategoryCard from "./CategoryCard";
import HelpCenterCardDetailComponent from "./HelpCenterCardDetailComponent";
import HelpCenterSearchResults from "./HelpCenterSearchResults";
import { FiHelpCircle } from "react-icons/fi";
import { useSelector } from "react-redux";
import { FORMS, MODULES } from "../../const";
import HelpCenterDeletedArticles from "./HelpCenterDeletedArticles";
import AddReleaseNote from "./AddReleaseNote";

const HelpCenterHome = ({
  selectedKey,
  setSelectedKey,
  query,
  setQuery,
  searchClicked,
  setSearchClicked,
}) => {
  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const helpCenterPermission = auth?.[FORMS?.HELP_CENTER?.HELP_CENTER?.form];
  console.log("helpCenterPermission", helpCenterPermission);
  const createArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.CREATE;
  const deleteArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.DELETE;
  const updateArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.UPDATE;
  const viewArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.VIEW;

    const createReleasePermission =
    auth?.[FORMS?.HELP_CENTER?.RELEASE_NOTE?.form]?.FORM?.CREATE;
    console.log("permission",createReleasePermission);

  const [searchResults, setSearchResults] = useState([]);
  const [recentSearches, setRecentSearches] = useState(() => {
    const stored = localStorage.getItem("recentHelpSearches");
    return stored ? JSON.parse(stored) : [];
  });
  const [selectedCard, setSelectedCard] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [articleId, setArticleId] = useState(null);
  const [helpTopics, setHelpTopics] = useState([]);
  const [isArticleLoading, setIsArticleLoading] = useState(false);
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const [deletedHelpTopics, setDeletedHelpTopics] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  const componentMap = {
    1: (
      <HelpCenterCardDetailComponent
        setSelectedKey={setSelectedKey}
        searchClicked={searchClicked}
        selectedCard={selectedCard}
        setEditMode={setEditMode}
        setArticleId={setArticleId}
        setSelectedCard={setSelectedCard}
        setUpdateNeeded={setUpdateNeeded}
        updateNeeded={updateNeeded}
      />
    ),
    2: (
      <HelpCenterSearchResults
        results={searchResults}
        setSelectedKey={setSelectedKey}
        searchClicked={searchClicked}
        setSearchClicked={setSearchClicked}
        setSelectedCard={setSelectedCard}
        setUpdateNeeded={setUpdateNeeded}
        setResults={setSearchResults}
        selectedKey={selectedKey}
      />
    ),
    3: (
      <AddHelpArticle
        editMode={editMode}
        articleId={editMode ? articleId : null}
        setSelectedKey={setSelectedKey}
        setEditMode={setEditMode}
        previousKey={selectedKey}
        setUpdateNeeded={setUpdateNeeded}
        allArticles={helpTopics}
      />
    ),
    4: (
      <HelpCenterDeletedArticles
        setSelectedKey={setSelectedKey}
        searchClicked={searchClicked}
        setSelectedCard={setSelectedCard}
        setUpdateNeeded={setUpdateNeeded}
        deletedHelpTopics={deletedHelpTopics}
        setDeletedHelpTopics={setDeletedHelpTopics}
        selectedKey={selectedKey}
      />
    ),
    5: (
      <AddReleaseNote
        setSelectedKey={setSelectedKey}
      />
    ),
  };

  const fetchArticles = async () => {
    setIsArticleLoading(true);
    const allArticles = await getArticles();
    if (allArticles && allArticles.length > 0) {
      const articlesWithIcons = allArticles?.map((article) => ({
        ...article,
        key: 1, // or article.articleId,
        icon: <FiHelpCircle size={45} />,
        docCount: article.documents.length,
        isVideo: article.videoEmbedHtml !== "" ? true : false,
      }));
      setHelpTopics(articlesWithIcons);
    } else {
      setHelpTopics([]);
    }

    // const deletedArticles = await getDeletedArticles();
    // if (deletedArticles && deletedArticles.length > 0) {
    //   const articlesWithIcons = deletedArticles?.map((article) => ({
    //     ...article,
    //     key: 1, // or article.articleId,
    //     icon: <FiHelpCircle size={45} />,
    //     docCount: article.documents?.length,
    //     isVideo: article.videoEmbedHtml !== "" ? true : false,
    //   }));
    //   setDeletedHelpTopics(articlesWithIcons);
    // } else {
    //   setDeletedHelpTopics([]);
    // }

    setIsArticleLoading(false);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  console.log("helpTopics", helpTopics);

  useEffect(() => {
    if (updateNeeded) {
      fetchArticles();
      setUpdateNeeded(false);
    }
  }, [updateNeeded]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  if (selectedKey) {
    return componentMap[selectedKey];
  }
  const handleSearch = () => {
    setSearchClicked(true);
    setEditMode(true);
    const q = query.trim().toLowerCase();
    if (!q) return;

    const matches = helpTopics?.filter(
      ({ title, description }) =>
        (title ?? "").toLowerCase().includes(q) ||
        (description ?? "").toLowerCase().includes(q)
    );

    setSearchResults(matches);
    setSelectedKey(2); // numeric key for search results

    const updatedSearches = [q, ...recentSearches.filter((s) => s !== q)].slice(
      0,
      5
    );
    setRecentSearches(updatedSearches);
    localStorage.setItem("recentHelpSearches", JSON.stringify(updatedSearches));
  };

  console.log("selected key:", selectedKey);
  console.log("selected card:", selectedCard);

  const handleDelete = async (articleId) => {
    setIsDeleting(true);
    try {
      await deleteArticle(articleId);
      await fetchArticles();
      toast.success("Article deleted successfully", {
        autoClose: 5000,
        containerId: "Modal",
      });
    } catch (error) {
      console.error("Failed to delete article:", error);
      toast.error("Failed to delete article.", {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
    setIsDeleting(false);
  };

  const handleArticleClick = async (topic) => {
    try {
      setSelectedCard(topic);
      setSelectedKey(1);
      await setViewCount(topic.articleId);
      setUpdateNeeded(true);
    } catch (error) {
      console.error("Failed to set view count:", error);
    }
  };

  return (
    <>
      {isArticleLoading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <div className="help-center-container">
            <div className="help-center-header">
              <img
                src={logo_icon}
                alt="logo-icon"
                className="help-center-logo-icon"
              />
              <div className="logo">HELP CENTER</div>
            </div>

            <div className="help-center-content">
              <div className="help-center-title">
                <h1 className="ask-text">You ask.</h1>
                <h1 className="answer-text">We answer.</h1>
              </div>

              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Search for anything..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <button onClick={handleSearch}>Search</button>
              </div>

              <div className="popular-searches">
                Popular searches —{" "}
                {recentSearches.length > 0 ? (
                  recentSearches.map((s, idx) => (
                    <span
                      key={idx}
                      style={{ cursor: "pointer", marginRight: 8 }}
                      onClick={() => {
                        setQuery(s);
                        handleSearch();
                      }}
                    >
                      {s}
                      {idx < recentSearches.length - 1 && ","}
                    </span>
                  ))
                ) : (
                  <span>
                    Password Recovery, Change Login Password, Request Approval
                  </span>
                )}
              </div>
            </div>

{createReleasePermission && (
  <div
    className="floating-button"
    style={{
      right: "170px"
    }}
    onClick={() => {
      setEditMode(false);
      setSelectedKey(5);
    }}
  >
    <span
      role="img"
      aria-label="release-note"
      style={{
        fontSize: "20px",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      📝
    </span>
  </div>
)}

{createArticlePermission && (
              <div
                className="floating-button"
                onClick={() => {
                  setEditMode(false);
                  setSelectedKey(3);
                }}
              >
                <span
                  role="img"
                  aria-label="add"
                  style={{
                    fontSize: "20px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  ➕
                </span>
              </div>
            )}
            {updateArticlePermission && (
              <div
                className="bin-button"
                onClick={() => {
                  setEditMode(false);
                  setSelectedKey(4);
                }}
              >
                <span
                  role="img"
                  aria-label="recycle-bin"
                  style={{
                    fontSize: "20px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  🗑️
                </span>
              </div>
            )}
          </div>
          <div>
            <div
              style={{
                padding: "20px 20px",
                cursor: "pointer",
                height: "80vh",
                overflowY: "auto",
              }}
            >
              {helpTopics && helpTopics?.length === 0 ? (
                <h3 style={{ textAlign: "center" }}>No Content found</h3>
              ) : (
                helpTopics?.map((topic) => (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <CategoryCard
                      icon={topic.icon}
                      title={topic.title}
                      description={topic.slug}
                      views={topic.viewCount}
                      recover={false}
                      isVideo={topic.isVideo}
                      docCount={topic.docCount}
                      onClick={() => handleArticleClick(topic)}
                      onDeleteClick={() => handleDelete(topic.articleId)}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
      {/* {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ...`} />
        </div>
      )} */}
    </>
  );
};

export default HelpCenterHome;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
